import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { Questionnaire } from "./types";

type Response = {
  data?: Questionnaire;
  error?: ApiError;
};

export const GetQuestionnaire = async (): Promise<Response> => {
  try {
    const response = await axios.get("/cert-roadmap/questionnaire");
    return { data: response.data.data };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.response) {
      return {
        error: {
          statusCode: error.response.status,
          message: error.response.data.message,
          error: error.response.data.error,
        },
      };
    }
    return {
      error: { statusCode: 500, message: "An unexpected error occurred" },
    };
  }
};
